import * as React from 'react';

import {connect} from "react-redux";
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";

import {translate} from 'react-i18next';

import {Segment, List, Header, Icon, Divider} from 'semantic-ui-react';

import Dialog from "../../components/Dialogs/Dialog";
import Button from "../../components/Button";
import {formatDate} from '../../components/Table/dataHandler/Utils';
import {ENewsPriority, NewsDto} from "../../services/Client";
import {compose, Dispatch} from "redux";
import AdminViewActions from "../../redux/actions/AdminViewActions";
import {selectActiveNews} from '../../redux/selectors';
import {IReduxState} from '../../redux/IReduxState';

interface IOwnProps {
    history:any;
 }

interface IMapDispatchToProps {
    getActiveNews: () => void;
}

interface IMapStateToProps {
    activeNews: NewsDto[] | undefined;

}

interface INotesAndNewsProps extends
    ITranslatedComponent,
    IOwnProps,
    IMapStateToProps,
    IMapDispatchToProps { }

interface INotesAndNewsState {
    dialogOpen: boolean;
    selectedNote: NewsDto | null;
}

class NotesAndNews extends React.Component<INotesAndNewsProps, INotesAndNewsState> {
    constructor(props: INotesAndNewsProps) {
        super(props);
        this.state = {
            dialogOpen: false,
            selectedNote: null,
        };
    }

    componentDidMount() {
        this.props.getActiveNews();
    }

    render() {
        const {t, activeNews,history} = this.props;
        const {dialogOpen, selectedNote} = this.state;

        return (
            <Segment className='news-list'>
                <div className='header'>
                    <Header className='start-view-tile-header'>{t("START_VIEW:NEWS_HEADER")}</Header>
                    <img src='./images/faq.png' alt='faq' onClick={()=>history.push("/support")} style={{cursor:'pointer'}} />
                </div>

                <Divider />
                {activeNews && activeNews.length > 0
                    ?
                    <List
                        divided={true}
                        relaxed={true}
                        style={{overflowY: "auto", height: '215px', paddingBottom: '5px'}}
                    >
                        {activeNews.map((note: NewsDto) => (
                            <List.Item
                                key={note.objectId}
                                onClick={(): void => this.setState({dialogOpen: true, selectedNote: note})}
                            >
                                <List.Content floated="right">
                                    <List.Icon name="arrow right" />
                                </List.Content>
                                <List.Content>
                                    <List.Header as='a'>
                                        {note.priority === ENewsPriority.HIGH ?
                                            <div className={'color--red'}>
                                                <Icon name='exclamation' color='red' />
                                                {note.title}
                                            </div>
                                            : note.title}
                                    </List.Header>
                                    {note.metadata && note.metadata.changedTimestamp &&
                                        <List.Description>
                                            {t("NOTES_AND_NEWS:EDITED")}: {formatDate(note.metadata.changedTimestamp)}
                                        </List.Description>
                                    }
                                </List.Content>
                            </List.Item>
                        ))}
                    </List>
                    :
                    <span>{t("START_VIEW:NO_NEWS")}</span>
                }

                {dialogOpen && selectedNote &&
                    <Dialog
                        open={dialogOpen}
                        customStyleClassName='start-view-news-dialog'
                        actions={[
                            <Button
                                key={'close'}
                                icon={"ban"}
                                onClick={() => this.setState({dialogOpen: false, selectedNote: null})}
                            />
                        ]}
                        title={
                            <div className='display--flex align-items--center justify-content--space-between'>
                                <span>
                                    <Icon name='newspaper outline' size='large' />
                                    {selectedNote.title}
                                </span>
                                {selectedNote && selectedNote.metadata &&
                                    <div style={{fontSize: 14, color: 'grey', fontWeight: 'normal'}}>
                                        {selectedNote.metadata.createdTimestamp &&
                                            <span className='margin-right--10px'>
                                                {t("NOTES_AND_NEWS:CREATED")}: {formatDate(selectedNote.metadata.createdTimestamp)}
                                            </span>
                                        }
                                        {selectedNote.metadata.changedTimestamp && selectedNote.metadata.changedTimestamp !== selectedNote.metadata.createdTimestamp &&
                                            <span>{t("NOTES_AND_NEWS:EDITED")}: {formatDate(selectedNote.metadata.changedTimestamp)}</span>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    >
                        <p style={{whiteSpace: "pre-wrap", overflowWrap: "break-word"}}>
                            {selectedNote.content}
                        </p>
                    </Dialog>
                }
            </Segment>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    activeNews: selectActiveNews(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: INotesAndNewsProps): IMapDispatchToProps => ({
    getActiveNews: () => dispatch(AdminViewActions.GetActiveNews(ownProps.t)),
});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["START_VIEW", "NOTES_AND_NEWS"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(NotesAndNews);



// WEBPACK FOOTER //
// ./src/views/MainView/NotesAndNews.tsx